<template>
  <div>
    <div class="memberSearch">
      <h4 class="mb-3">Parameters of search</h4>
      <div class="textInfo mb-3">Select plan to see its members or add new member</div>
      <div v-if="isLoadingPlans">
        <span
          ><v-progress-circular
            indeterminate
            :size="20"
            color="blue lighten-5"
            class="mr-2"
          ></v-progress-circular
          >Loading..</span
        >
      </div>
      <v-select
        v-else
        :items="schemeList"
        item-value="Id"
        item-text="ShortName"
        @change="onPlanChanged"
        v-model="currentPlan"
        label="Select plan"
        dense
        outlined
      >
      </v-select>
      <div v-if="isLoadingForms">
        <v-progress-circular
          :size="20"
          color="primary"
          class="mr-2"
          indeterminate
        ></v-progress-circular>
        Loading..
      </div>

      <div v-else>
        <v-form @submit.prevent="searchMembers">
          <v-expansion-panels accordion elevation="0" v-model="searchPanel">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span class="blue--text text--darken-3">More parameters</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mb-3 mt-1 parametersTitle">
                  <span class="textInfo">Enter member(s) parameters</span>
                  <v-btn color="primary" plain id="clearBtn" @click="clearForm"
                    >Clear parameters</v-btn
                  >
                </div>
                <FormPanel :formElements="formElements" panelName="Panel1" :readOnly="false" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <div class="btnContainer d-flex align-center justify-space-between">
            <v-btn outlined color="primary" @click="addNewMember">Add new member</v-btn>
            <div class="d-flex align-center">
              <v-btn depressed class="mr-2" color="primary" type="submit"
                ><v-icon>mdi-magnify</v-icon> Search</v-btn
              >

              <v-btn depressed icon color="primary" @click="advancedSearchDialog = true"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
          </div>
        </v-form>
      </div>
    </div>

    <!-- For style purposes only -->
    <div class="gap"></div>

    <div class="serchResults">
      <SearchResult />
    </div>

    <v-dialog v-model="advancedSearchDialog" max-width="750">
      <AdvancedSearch @closeDialog="advancedSearchDialog = false"></AdvancedSearch>
    </v-dialog>
  </div>
</template>

<script>
import FormPanel from '@/components/FormPanel.vue';
import SearchResult from './SearchResult.vue';
import AdvancedSearch from '@/components/AdvancedSearch.vue';

export default {
  components: { FormPanel, SearchResult, AdvancedSearch },
  name: 'Search',
  data() {
    return {
      currentPlan: 0,
      isLoadingPlans: true,
      isLoadingForms: false,
      schemeList: [],
      formElements: [],
      searchPanel: null,
      advancedSearchDialog: false,
    };
  },
  mounted: function () {
    if (this.token) this.getSchemeList();
    if (this.$store.getters.currentPlanId) {
      this.currentPlan = this.$store.getters.currentPlanId;
      this.getForm();
    }
  },
  computed: {
    showSerchMembersForm() {
      if (this.currentPlan) return true;
      return false;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    token() {
      return this.$store.getters.token;
    },
  },
  methods: {
    onPlanChanged() {
      this.$store.commit('setCurrentPlan', this.currentPlan);
      this.updateUserPlan();
    },
    searchMembers() {
      const fields = {};
      for (let item of this.formElements) {
        fields[item.FieldId] = item.Value;
      }
      fields['PlanId'] = this.currentPlan;
      this.$store.commit('setAdvancedSearch', { advancedSearch: false, includeAllPlans: false });
      this.$store.commit('setSearchMemberFields', fields);
      this.searchPanel = null;
    },
    clearForm() {
      this.formElements.forEach((x) => {
        x.Value = null;
      });
    },
    addNewMember() {
      this.$store.commit('setSelectedMember', null);
      this.$router.push({ name: 'BasicData', path: '/MemberDetails' });
    },
    getFormName() {
      return this.$route.name;
    },
    async getSchemeList() {
      try {
        this.isLoadingPlans = true;
        let response = await this.$api.get('/plans/getplanlist');

        if (!response.data.length) {
          const msg = 'Unable to load plans';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.schemeList = response.data;
        this.isLoadingPlans = false;
      } catch (err) {
        console.log(err);
      }
    },
    async getForm() {
      try {
        this.isLoadingForms = true;
        const formName = this.getFormName();
        let response = await this.$api.get(
          '/datadictionary/GetFormElements?formName=' + formName + '&planId=' + this.currentPlan
        );

        if (response.data && response.data.length) {
          var elements = response.data.filter((f) => f.Visible == true);
          this.formElements = elements;
          this.isLoadingForms = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async updateUserPlan() {
      try {
        let response = await this.$api.post('/User/UpdateUserPlan?planId=' + this.currentPlan);

        if (!response) {
          const msg = 'Unable to set plan';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
  watch: {
    currentPlanId: function () {
      this.currentPlan = this.currentPlanId;
      this.$store.commit('setTaggedMembers', []);
      const advancedSearch = this.$store.getters.advancedSearch;
      if (!advancedSearch.includeAllPlans) {
        this.$store.commit('setSelectedMember', null);
      }
      this.getForm();
    },
    token() {
      if (this.token) this.getSchemeList();
    },
  },
};
</script>

<style>
.memberSearch {
  width: 100%;
  max-width: 600px;
  min-width: 250px;
  padding: 20px;
}
button.v-expansion-panel-header {
  padding: 0;
  min-height: 32px;
  margin-bottom: 10px;
  font-weight: bold;
}
.memberSearch .v-expansion-panel::before {
  box-shadow: none;
}
.memberSearch .v-expansion-panel-content__wrap {
  padding: 0;
}
.memberSearch .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 32px;
}
.memberSearch .v-expansion-panel-header {
  box-shadow: none;
}
.gap {
  min-width: 100%;
  min-height: 20px;
  background: #e5e5e5;
}
.parametersTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
#clearBtn {
  padding: 0;
  height: auto;
}
</style>
